import VueGtag from 'vue-gtag';

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';

Vue.use(
  VueGtag,
  {
    config: { id: process.env.VUE_APP_GA },
  },
  router,
);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
